import { apiBaseUrl } from "@/config/api"

function setMeta(name, value, attr = "name") {
  if (value === null || typeof value === "undefined" || value === "") return
  let el = document.querySelector(`meta[${attr}="${name}"]`)
  if (!el) {
    el = document.createElement("meta")
    el.setAttribute(attr, name)
    document.head.appendChild(el)
  }
  el.setAttribute("content", value)
}

export function applyPageSeo(seo) {
  if (!seo || typeof seo !== "object") return

  if (seo.title) {
    document.title = seo.title
  }
  if (seo.description) {
    setMeta("description", seo.description)
  }
  if (seo.keywords) {
    setMeta("keywords", seo.keywords)
  }
  if (typeof window.applyPageSeo === "function") {
    window.applyPageSeo(seo)
  }
}

export function fetchPageSeo(path) {
  const apiPath = `${apiBaseUrl}seo?path=${encodeURIComponent(path || "/")}`
  return fetch(apiPath)
    .then((response) => response.json())
    .then((data) => {
      applyPageSeo({
        title: data.title,
        description: data.description,
        keywords: data.keywords,
      })
      return data
    })
    .catch(() => null)
}
